import axios from 'axios';
import get from 'lodash/get';
import { fetchStripeCustomer } from './stripeCustomerActions';
import { selectDayFromUserObject } from './filterActions';

export const ACTIVATE_TEACHER_LOADING = 'ACTIVATE_TEACHER_LOADING';
export const ACTIVATE_TEACHER_SUCCESS = 'ACTIVATE_TEACHER_SUCCESS';
export const ACTIVATE_TEACHER_ERROR = 'ACTIVATE_TEACHER_ERROR';

export const USER_LOGIN_LOADING = 'USER_LOGIN_LOADING';
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
export const USER_LOGIN_ERROR = 'USER_LOGIN_ERROR';

export const USER_LOGOUT = 'USER_LOGOUT';

export const RESET_PASSWORD_LOADING = 'RESET_PASSWORD_LOADING';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_ERROR = 'RESET_PASSWORD_ERROR';

export const UPDATE_PROFILE_LOADING = 'UPDATE_PROFILE_LOADING';
export const UPDATE_PROFILE_SUCCESS = 'UPDATE_PROFILE_SUCCESS';
export const UPDATE_PROFILE_ERROR = 'UPDATE_PROFILE_ERROR';

export const REAUTHENTICATE_LOADING = 'REAUTHENTICATE_LOADING';
export const REAUTHENTICATE_SUCCESS = 'REAUTHENTICATE_SUCCESS';
export const REAUTHENTICATE_ERROR = 'REAUTHENTICATE_ERROR';

export const PAUSE_MEMBERSHIP_LOADING = 'PAUSE_MEMBERSHIP_LOADING';
export const PAUSE_MEMBERSHIP_SUCCESS = 'PAUSE_MEMBERSHIP_SUCCESS';
export const PAUSE_MEMBERSHIP_ERROR = 'PAUSE_MEMBERSHIP_ERROR';

export const RESUME_MEMBERSHIP_LOADING = 'RESUME_MEMBERSHIP_LOADING';
export const RESUME_MEMBERSHIP_SUCCESS = 'RESUME_MEMBERSHIP_SUCCESS';
export const RESUME_MEMBERSHIP_ERROR = 'RESUME_MEMBERSHIP_ERROR';

export const UPDATE_CONGRATS_STATUS = 'UPDATE_CONGRATS_STATUS';
export const UPDATE_UPSELL_DATA = 'UPDATE_UPSELL_DATA';

export const SET_BOOKING_DATA = 'SET_BOOKING_DATA';

export const REFRESH_USER_LOADING = 'REFRESH_USER_LOADING';
export const REFRESH_USER_SUCCESS = 'REFRESH_USER_SUCCESS';
export const REFRESH_USER_ERROR = 'REFRESH_USER_ERROR';

export const signupAsync = (email, name, password) => async (dispatch) => {
  dispatch({ type: USER_LOGIN_LOADING });

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/auth/signUp`,
      {
        email,
        name,
        password,
      },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    dispatch({
      type: USER_LOGIN_SUCCESS,
      payload: response.data.data,
    });
    return response.data.data;
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') {
      console.log('catch', error);
    }

    let response = get(error, 'response.data');
    if (!response) {
      response = { _error: 'Network Error' };
    }

    dispatch({
      type: USER_LOGIN_ERROR,
      payload: response,
    });

    throw error;
  }
};

export function signup(email, name, password, bookingData, success, failure) {
  return (dispatch) => {
    // TODO: this dispatch should definitely not be here
    // Move this bookingData management to where it belongs
    dispatch({
      type: SET_BOOKING_DATA,
      payload: bookingData,
    });

    dispatch({ type: USER_LOGIN_LOADING });

    axios
      .post(
        `${process.env.REACT_APP_BACKEND_URL}/auth/signUp`,
        {
          email,
          name,
          password,
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      )
      .then((response) => {
        dispatch({
          type: USER_LOGIN_SUCCESS,
          payload: response.data.data,
        });
        success && success(response);
      })
      .catch((error) => {
        if (process.env.NODE_ENV !== 'production') {
          console.log('catch', error);
        }

        let response = get(error, 'response.data');
        if (!response) {
          response = { _error: 'Network Error' };
        }

        dispatch({
          type: USER_LOGIN_ERROR,
          payload: response,
        });
        failure && failure(response);
      });
  };
}

export function login(
  email,
  password,
  remember,
  bookingData,
  success,
  failure
) {
  return (dispatch) => {
    dispatch({
      type: SET_BOOKING_DATA,
      payload: bookingData,
    });

    dispatch({ type: USER_LOGIN_LOADING });

    axios
      .post(
        `${process.env.REACT_APP_BACKEND_URL}/auth/signIn`,
        {
          email,
          password,
          remember,
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      )
      .then((response) => {
        // if (!bookingData) {
        //   dispatch(selectDayFromUserObject(response.data.data.account));
        // }

        dispatch({
          type: USER_LOGIN_SUCCESS,
          payload: response.data.data,
        });

        success && success();
      })
      .catch((error) => {
        if (process.env.NODE_ENV !== 'production') {
          console.log('catch', error);
        }

        let response = get(error, 'response.data');
        if (!response) {
          response = { _error: 'Network Error' };
        }

        dispatch({
          type: USER_LOGIN_ERROR,
          payload: response,
        });
        failure && failure(response);
      });
  };
}

export function signUpWithGoogle(
  idToken,
  remember,
  bookingData,
  success,
  failure
) {
  return (dispatch) => {
    dispatch({
      type: SET_BOOKING_DATA,
      payload: bookingData,
    });

    dispatch({ type: USER_LOGIN_LOADING });

    axios
      .post(
        `${process.env.REACT_APP_BACKEND_URL}/auth/signUpWithGoogle`,
        {
          idToken,
          remember,
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      )
      .then((response) => {
        dispatch({
          type: USER_LOGIN_SUCCESS,
          payload: response.data.data,
        });
        success && success();
      })
      .catch((error) => {
        if (process.env.NODE_ENV !== 'production') {
          console.log('catch', error);
        }

        let response = get(error, 'response.data');
        if (!response) {
          response = { _error: 'Network Error' };
        }

        dispatch({
          type: USER_LOGIN_ERROR,
          payload: response,
        });
        failure && failure(response);
      });
  };
}

// export function logout(success, failure) {
export function logout() {
  return (dispatch) => {
    dispatch({ type: USER_LOGOUT });
    dispatch(selectDayFromUserObject(null));
  };
}

export function requestResetPassword(email, success, failure) {
  return (dispatch) => {
    dispatch({ type: RESET_PASSWORD_LOADING });

    axios
      .post(
        `${process.env.REACT_APP_BACKEND_URL}/auth/requestPasswordReset`,
        {
          email,
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      )
      .then((response) => {
        dispatch({
          type: RESET_PASSWORD_SUCCESS,
          payload: response.data.data,
        });
        success && success();
      })
      .catch((error) => {
        if (process.env.NODE_ENV !== 'production') {
          console.log('catch', error);
        }

        let response = get(error, 'response.data');
        if (!response) {
          response = { _error: 'Network Error' };
        }

        dispatch({
          type: RESET_PASSWORD_ERROR,
          payload: response,
        });
        failure && failure(response);
      });
  };
}

export function setPassword(password, token, success, failure) {
  return (dispatch) => {
    dispatch({ type: RESET_PASSWORD_LOADING });

    axios
      .post(
        `${process.env.REACT_APP_BACKEND_URL}/auth/setPassword`,
        {
          password,
          token,
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      )
      .then((response) => {
        dispatch({
          type: RESET_PASSWORD_SUCCESS,
          payload: response.data.data,
        });
        success && success();
      })
      .catch((error) => {
        if (process.env.NODE_ENV !== 'production') {
          console.log('catch', error);
        }

        let response = get(error, 'response.data');
        if (!response) {
          response = { _error: 'Network Error' };
        }

        dispatch({
          type: RESET_PASSWORD_ERROR,
          payload: response,
        });
        failure && failure(response);
      });
  };
}

export function refreshCurrentUser() {
  return (dispatch, getState) => {
    const state = getState();

    dispatch({ type: REFRESH_USER_LOADING });

    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/account/profile`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.user.token}`,
        },
      })
      .then((response) => {
        dispatch({
          type: REFRESH_USER_SUCCESS,
          payload: response.data.data,
        });
      })
      .catch((error) => {
        if (process.env.NODE_ENV !== 'production') {
          console.log('catch', error);
        }

        let response = get(error, 'response.data');
        if (!response) {
          response = { _error: 'Network Error' };
        }

        dispatch({
          type: REFRESH_USER_ERROR,
          payload: response,
        });
      });
  };
}

export function reauthenticate(success, failure) {
  return (dispatch, getState) => {
    const state = getState();

    dispatch({ type: REAUTHENTICATE_LOADING });

    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/account/profile`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.user.token}`,
        },
      })
      .then((response) => {
        dispatch(selectDayFromUserObject(response.data.data.account));

        dispatch({
          type: REAUTHENTICATE_SUCCESS,
          payload: response.data.data,
        });
        success && success(response.data.data);
      })
      .catch((error) => {
        if (process.env.NODE_ENV !== 'production') {
          console.log('catch', error);
        }

        let response = get(error, 'response.data');
        if (!response) {
          response = { _error: 'Network Error' };
        }

        dispatch({
          type: REAUTHENTICATE_ERROR,
          payload: response,
        });
        failure && failure(response);
      });
  };
}

export function updateCongratsStatus(status) {
  return (dispatch) => {
    dispatch({
      type: UPDATE_CONGRATS_STATUS,
      payload: status,
    });
  };
}

export function updateProfile(data, isOnboard, success, failure) {
  return (dispatch, getState) => {
    const state = getState();
    if (!state.user.token) {
      return;
    }

    dispatch({ type: UPDATE_PROFILE_LOADING });

    axios
      .put(`${process.env.REACT_APP_BACKEND_URL}/account/profile`, data, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.user.token}`,
        },
      })
      .then((response) => {
        if (isOnboard) {
          dispatch(selectDayFromUserObject(response.data.data));

          dispatch(updateCongratsStatus('PENDING'));
        }

        dispatch({
          type: UPDATE_PROFILE_SUCCESS,
          payload: response.data.data,
        });
        success && success();
      })
      .catch((error) => {
        if (process.env.NODE_ENV !== 'production') {
          console.log('catch', error);
        }

        let response = get(error, 'response.data');
        if (!response) {
          response = { _error: 'Network Error' };
        }

        dispatch({
          type: UPDATE_PROFILE_ERROR,
          payload: response,
        });
        failure && failure(response);
      });
  };
}

export const purchaseTrialCredit = (coupon) => async (dispatch, getState) => {
  const state = getState();
  if (!state.user.token) {
    return;
  }

  const data = {};
  if (coupon) data.couponId = coupon.id;

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/account/purchaseTrialCredit`,
      data,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.user.token}`,
        },
      }
    );
    dispatch({
      type: UPDATE_PROFILE_SUCCESS,
      payload: response.data.data,
    });
  } catch (error) {
    throw error;
  }
};

export function activate(data, success, failure) {
  return (dispatch, getState) => {
    const state = getState();
    if (!state.user.token) {
      return;
    }
    axios
      .post(
        `${process.env.REACT_APP_BACKEND_URL}/account/profile/activate`,
        data,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${state.user.token}`,
          },
        }
      )
      .then((response) => {
        dispatch({
          type: UPDATE_PROFILE_SUCCESS,
          payload: response.data.data,
        });
        success && success();
      })
      .catch((error) => {
        dispatch({
          type: UPDATE_PROFILE_ERROR,
          payload: error,
        });
        failure && failure();
      });
  };
}

export function pauseMembership(
  subscriptionId,
  stripeCustomerId,
  stripePlanId,
  pausePeriod,
  success,
  failure
) {
  return (dispatch, getState) => {
    const state = getState();
    const data = { stripePlanId, stripeCustomerId, pausePeriod };

    dispatch({ type: PAUSE_MEMBERSHIP_LOADING });

    axios
      .post(
        `${process.env.REACT_APP_BACKEND_URL}/stripe/subscriptions/${subscriptionId}/pause`,
        data,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${state.user.token}`,
          },
        }
      )
      .then((response) => {
        dispatch(fetchStripeCustomer(stripeCustomerId));

        dispatch({
          type: PAUSE_MEMBERSHIP_SUCCESS,
          payload: response.data.data,
        });
        success && success();
      })
      .catch((error) => {
        if (process.env.NODE_ENV !== 'production') {
          console.log('catch', error);
        }

        let response = get(error, 'response.data');
        if (!response) {
          response = { _error: 'Network Error' };
        }

        dispatch({
          type: PAUSE_MEMBERSHIP_ERROR,
          payload: response,
        });
        failure && failure(response);
      });
  };
}

export function resumeMembership(stripeCustomerId, success, failure) {
  return (dispatch, getState) => {
    const state = getState();

    dispatch({ type: RESUME_MEMBERSHIP_LOADING });

    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/stripe/subscriptions/resume`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.user.token}`,
        },
      })
      .then((response) => {
        dispatch(fetchStripeCustomer(stripeCustomerId));

        dispatch({
          type: RESUME_MEMBERSHIP_SUCCESS,
          payload: response.data.data,
        });

        success && success();
      })
      .catch((error) => {
        if (process.env.NODE_ENV !== 'production') {
          console.log('catch', error);
        }

        let response = get(error, 'response.data');
        if (!response) {
          response = { message: 'Network Error' };
        }

        dispatch({
          type: RESUME_MEMBERSHIP_ERROR,
          payload: response,
        });
        failure && failure(response);
      });
  };
}

export function updateUpsellData(data) {
  return (dispatch) => {
    dispatch({
      type: UPDATE_UPSELL_DATA,
      payload: data,
    });
  };
}

export function setBookingData(bookingData) {
  return (dispatch) => {
    dispatch({
      type: SET_BOOKING_DATA,
      payload: bookingData,
    });
  };
}

export function activateTeacher(email, success, failure) {
  return (dispatch, getState) => {
    const state = getState();
    if (!state.user.token) {
      return;
    }

    dispatch({ type: ACTIVATE_TEACHER_LOADING });

    axios
      .post(
        `${process.env.REACT_APP_BACKEND_URL}/account/profile/activateTeacher`,
        {},
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${state.user.token}`,
          },
        }
      )
      .then((response) => {
        dispatch({
          type: ACTIVATE_TEACHER_SUCCESS,
          payload: response.data.data,
        });
        success && success();
      })
      .catch((error) => {
        if (process.env.NODE_ENV !== 'production') {
          console.log('catch', error);
        }

        let response = get(error, 'response.data');
        if (!response) {
          response = { _error: 'Network Error' };
        }

        dispatch({
          type: ACTIVATE_TEACHER_ERROR,
          payload: response,
        });
        failure && failure(response);
      });
  };
}

export function getTrialCoupon(onSuccess) {
  return (dispatch, getState) => {
    const state = getState();
    if (!state.user.token) {
      return;
    }
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/account/trialUpgradeCoupon`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.user.token}`,
        },
      })
      .then((response) => {
        onSuccess(response.data.data.coupon);
      })
      .catch(() => {
        onSuccess(null);
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/userActions.js